import React from 'react'
// image import
import box from '../assets/img/boxshadow.png'
import covid from '../assets/img/covid.png'
import mp from '../assets/img/myportfolio.png'
import c from '../assets/img/Cv.png'
import Money from '../assets/img/money.png'

// >>>>>>>>>>> ICOn
import DevicesIcon from '@material-ui/icons/Devices';
import ComputerIcon from '@material-ui/icons/Computer';
import ImportantDevicesIcon from '@material-ui/icons/ImportantDevices';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import GitHubIcon from '@material-ui/icons/GitHub';
import HttpIcon from '@material-ui/icons/Http';
// >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
export default {
    name: "Al Hossain JIM",
    title : "Full stack Developer",
    birthday: '27th April 2000',
    Email : 'hossainaljim24@gmail.com',
    address: 'Dhaka, Narayangonj, Bangladesh',
    phone: '+880 1843687579',
    socile : {
        Facebook : {
            link : 'https://www.facebook.com/Exceptional.jim404',
            text: ' حسين أل جيم',
            icon : <FacebookIcon />
        },

        Linkdin : {
            link : 'https://www.linkedin.com/in/hossain-al-jim-793a981bb/',
            text: 'Hossain Al JIM',
            icon : <LinkedInIcon />
        },
        Instragram : {
            link : 'https://www.instagram.com/exceptional_jim/',
            text: 'exceptional_jim',
            icon : <InstagramIcon />       
        },
        Twitter : {
            link : 'https://twitter.com/DjangoJIM1',
            text: ' Django-JIM',
            icon : <TwitterIcon />
        },
        GitHub : {
            link : 'https://github.com/jim-2000',
            text: ' Al Hossain Jim',
            icon : <GitHubIcon />
        },
    },
    // aboutMe:'I am Mr. Al Hossain JIM and I’m a full-stack Web Developer and UI & UX Designer with a solid enterprise background of experience for the past 2+ years.\n\n Of fly of his forgot of delphis loved sins befell. To she if not his shrine, yet would who so lowly his near who. \n\n Lurked heavenly mine in sun he scorching, moths for his flow in to in for few from. Talethis sun adieu he might though steel land agen.\n\n Of fly of his forgot of delphis loved sins befell. To she if not his shrine, yet would who so lowly his near who',

    aboutReact: " Rect was developed at Facebook and it is one of the most used front end Javascript frameworks.I will develop front end UI from the given design. In addition to creating a beautiful web site, I will apply SEO principles to make certain that customers can easily locate your web site.",
   aboutPython: "I'm highly experienced with  django for more than one year. I have a great amount of experience in building rest api using  django. In the case of django I use django rest framework.I will build Django/Python web API for small, medium and large-scale companies or for Individuals and deploy it on your preferred server.",
   AboutThereact: "This is Al Hossain JIM and I’m a full-stack Web Developer. Job perfection and client satisfaction is my aim. I did 28 jobs and never got any negative or average reviews. you can check my Work history and feedback! With practical  experience in websites and web application development, I have an excellent understanding of how technology can be used to align the requirement of both the business and the customer.\n\nI am a professional Python  developer, mostly I work with Django,  NodeJS,  React,  WordPress, jQuery, AJAX, Bootstrap, MaterializeCss and many more technologies, but don't hesitate to work with any framework.I enjoy working on websites and that is what I have been doing every day for the last many years. I work quickly and efficiently, with attention to details.\n I will be glad to help you with any tasks for web development/customization/maintenance and happy to answer any questions you have.It iss important to me to build long term relationships with You, so I am primarily looking for long term projects.I am flexible with your working hours and I'm happy to work closely with any existing freelancers you work with. I look forward to hearing from you!\n\n With best regards,JIM",
 

    experiences :[
        {
            title : 'Juniour Developer ',
            date : '2019-2020',
            description : 'I was work in Eausa softoware Company as a Juniour Developer.'
        },
        {
            title : 'Computer Opearator ',
            date : '2018-2019',
            description : 'As a Computer Oparator I was work in 2y+ In Best One Digital Multimedia Company'
        },
        // {
        //     title : 'Juniour Developer 3 ',
        //     date : '2019-2020',
        //     description : 'Eau jaunes la folle les nus au, moi pôles des maries nuits gonflé. Deau et des, de confiture zones plus hideux plus faisaient et, ardents suis jaune aux exquise, mer gouffres des aux future. Léviathan les crouler dors ni froide, enlever pontons et bleuités plus sans.'
        // },
    ],

    Education :[
        {
            title : 'Secondary School Certificate – ',
            date : '2016-2017',
            description : 'In 2018 I was pass my School Life'
        },
        {
            title : 'Higher Secondary School Certificate   ',
            date : '2018-2019',
            description : 'In 2020 I was pass my High School '
        },
        // {
        //     title : 'Education 3 ',
        //     date : '2019-2020',
        //     description : 'Eau jaunes la folle les nus au, moi pôles des maries nuits gonflé. Deau et des, de confiture zones plus hideux plus faisaient et, ardents suis jaune aux exquise, mer gouffres des aux future. Léviathan les crouler dors ni froide, enlever pontons et bleuités plus sans.'
        // },
    ],

    WorkHistory :[
        {
            title : 'Juniour Developer ',
            date : '2019-2020',
            description : 'Eau jaunes la folle les nus au, moi pôles des maries nuits gonflé. Deau et des, de confiture zones plus hideux plus faisaient et, ardents suis jaune aux exquise, mer gouffres des aux future. Léviathan les crouler dors ni froide, enlever pontons et bleuités plus sans.'
        },
        {
            title : 'Juniour Developer2 ',
            date : '2019-2020',
            description : 'Eau jaunes la folle les nus au, moi pôles des maries nuits gonflé. Deau et des, de confiture zones plus hideux plus faisaient et, ardents suis jaune aux exquise, mer gouffres des aux future. Léviathan les crouler dors ni froide, enlever pontons et bleuités plus sans.'
        },
        {
            title : 'Juniour Developer 3 ',
            date : '2019-2020',
            description : 'Eau jaunes la folle les nus au, moi pôles des maries nuits gonflé. Deau et des, de confiture zones plus hideux plus faisaient et, ardents suis jaune aux exquise, mer gouffres des aux future. Léviathan les crouler dors ni froide, enlever pontons et bleuités plus sans.'
        },
    ],

    services : [
        {
            title: 'Font End Developer',
            description : 'I have a 1y+ practical Knowledge In font End Designe. I will use Latest Technology',
            icon : <ImportantDevicesIcon />
        },

        {
            title: 'Back End Developer',
            description : 'I Will be your Back End Developer. I have 2y+ solid Knowledge in Python. Django is The Powerfull Framework ',
            icon : <ComputerIcon />
        },

        {
            title: 'Full Stack Developer',
            description : 'I will be your Full Stack Developer. I will latest and Powerfull Technology ',
            icon : <DevicesIcon />
        },
       
    ],
    skill : [
        {
            title : 'Font End Diveloper',
            description: [
                // 'HTML/CSS',
                // 'SCSS',
                'JavaScript',
                'Jquery',
                'Bootstrap',
                'Materializecss',
                'React js',
                'Redux',
                'Material Ui'
            ]
        },
        {
            title : 'Back End Diveloper',
            description: [
                // 'HTML/CSS',
                // 'SCSS',
                'Python',
                'Django',
                'Node js',
                'Firebase'
              
            ]
        },
        {
            title : 'Database',
            description: [
                
           
                ' My sql'
            ]
        },
        {
            title : 'Sourse Control',
            description: [
               
              
                'Git',
                'Github'
               
            ]
        },
    ],
    portfolio: [
        // React Project is Hare 
        {
            tag: 'React',
            image:covid,
            title: ' React Live Covid-19 Project',
            Captaion: "React Live Covid-19 Worldwide Status ",
            description: 'You Can see Live covid-19 pandemic situation. Worldwide and also a specific Country Link is Under by Discription  ',
            url: [
                {
                    link: 'https://covid-19-1f993.web.app/',
                    icon: <HttpIcon /> 

                },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
            ]

        },

        {
            tag: 'React',
            image: mp,
            title: ' React Hot Project',
            Captaion: "The React Holo Project",

            description: ' In This Project I will use styled Component also Css flexbox and Bootstrap also and some of materializeCss. This Website is Under by constractio \n\n Link is Under by Discription',
            url: [
                {
                    link: 'https://myportfolio-12-21-2000.web.app/',
                    icon: <HttpIcon /> 

                },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
            ]

        },
        {
            tag: 'React',
            image:box,
            title: ' The HOOK ',
            Captaion: "React Hot Project ",

            description: 'This is My on of the Hot project. In This Project we will see how State Change. How hook Change our Component etc etc.',
            url: [
                {
                    link: 'https://boxshadow.web.app/',
                    icon: <HttpIcon /> 

                },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
            ]

        },

        {
            tag: 'React',
            image:c,
            title: ' The Resume Website ',
            Captaion: "React Cool Resume ",

            description: 'This is My on of Good project. In This Project I was use React, Bootstrap, Css3, Material UI etc etc. In this project Everything is going on api like data and image and also other Thing  ',
            url: [
                {
                    link: 'https://portfolio-2e7c8.web.app/',
                    icon: <HttpIcon /> 

                },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
            ]

        },
        {
            tag: 'React',
            image:Money,
            title: ' React Personal Money Management Project',
            Captaion: "React Personal Money Management ",
            description: 'In This app I was use Context api. You cand see how state is working and you will how to manage store without Redux. Iam useing hare Context api and React Reducer wich is popular In this Time ',
            url: [
                {
                    link: 'https://money-a158e.web.app/',
                    icon: <HttpIcon /> 

                },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
                // {
                //     link: 'https://www.google.com',
                //     icon: <FacebookIcon /> 

                // },
            ]

        },
//>>>>>>>>>>>>>>>>>>>>>>>>> Python Project

        {
            tag: 'Python',
            image:'https://signal.avg.com/hubfs/Blog_Content/Avg/Signal/AVG%20Signal%20Images/Why%20your%20phone%20gets%20hot/Why_Your_Phone_Gets_Hot_and_How_to_Fix_It-Hero.jpg',
            title: ' Comeing Soon',
            Captaion: "This website is under by constraction",

            description: 'This is My Last Hot project',
            url: [
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
            ]

        },
        
        {
            tag: 'Python',
            image:'https://signal.avg.com/hubfs/Blog_Content/Avg/Signal/AVG%20Signal%20Images/Why%20your%20phone%20gets%20hot/Why_Your_Phone_Gets_Hot_and_How_to_Fix_It-Hero.jpg',
            title: ' Comeing Soon',
            Captaion: "This website is under by constraction",

            description: 'This is My Last Hot project',
            url: [
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
            ]

        },

//>>>>>>>>>>> JavaScript Project <<<<<<<<<<<
        {
            tag: 'Bootstrap',
            image:'https://signal.avg.com/hubfs/Blog_Content/Avg/Signal/AVG%20Signal%20Images/Why%20your%20phone%20gets%20hot/Why_Your_Phone_Gets_Hot_and_How_to_Fix_It-Hero.jpg',
            title: ' Bootstrap Hot Project',
            Captaion: "The Bootstrap Holo Project is comeing soon ",

            description: 'This is My Last Hot project',
            url: [
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
            ]

        },
        {
            tag: 'Bootstrap',
            image:'https://signal.avg.com/hubfs/Blog_Content/Avg/Signal/AVG%20Signal%20Images/Why%20your%20phone%20gets%20hot/Why_Your_Phone_Gets_Hot_and_How_to_Fix_It-Hero.jpg',
            title: ' Bootstrap Hot Project',
            Captaion: "The Bootstrap Holo Project is comeing soon",

            description: 'This is My Last Hot project',
            url: [
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
                {
                    link: 'https://www.google.com',
                    icon: <TwitterIcon /> 

                },
            ]

        },

// // // >>>>>>>>>> Java Project <<<<<<<<<<<<

// {
//     tag: 'Java',
//     image:'https://signal.avg.com/hubfs/Blog_Content/Avg/Signal/AVG%20Signal%20Images/Why%20your%20phone%20gets%20hot/Why_Your_Phone_Gets_Hot_and_How_to_Fix_It-Hero.jpg',
//     title: ' Java Hot Project',
//     description: 'This is My Last Hot project',
//     url: [
//         {
//             link: 'https://www.google.com',
//             icon: <TwitterIcon /> 

//         },
//         {
//             link: 'https://www.google.com',
//             icon: <TwitterIcon /> 

//         },
//         {
//             link: 'https://www.google.com',
//             icon: <TwitterIcon /> 

//         },
//     ]

// },
    ]
  

    


}